export default __webpack_public_path__ + "static/media/05.c6e0ac99.jpg";